import React from 'react';
import Hero from '../components/Hero';
import FeaturedGuests from '../components/FeaturedGuests';
import Newsletter from '../components/Newsletter';

const Home = () => (
  <>
    <Hero />
    <FeaturedGuests />
    <Newsletter />
  </>
);

export default Home;
